import { globalStyle, style } from '@vanilla-extract/css';

const rootElement = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  overflowX: 'hidden',
  selectors: {
    '&:not(.footer):not(.navbar)': {
      minHeight: '100dvh',
      backgroundColor: 'var(--background-color)',
    },
  },
});

const verticalSnapScroll = style({
  overflowY: 'auto',
  scrollSnapType: 'y mandatory',
  scrollPaddingTop: 30,
  height: '100vh',
});

const alignLeft = style({
  alignItems: 'flex-start',
});
const alignCenter = style({
  alignItems: 'center',
});
const alignRight = style({
  alignItems: 'flex-end',
});
const alignTop = style({
  justifyContent: 'flex-start',
});
const alignMiddle = style({
  justifyContent: 'center',
});
const alignBottom = style({
  justifyContent: 'flex-end',
});

const background = style({
  position: 'absolute',
  zIndex: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  inset: 0,
  userSelect: 'none',
});

globalStyle(`${background} img, ${background} video`, {
  pointerEvents: 'none',
});

const backgroundVideo = style({
  position: 'fixed',
  zIndex: 0,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
  padding: '0px !important',
  margin: '0px !important',
  overflow: 'hidden',
});

export default {
  rootElement,
  verticalSnapScroll,
  alignLeft,
  alignCenter,
  alignRight,
  alignTop,
  alignMiddle,
  alignBottom,
  background,
  backgroundVideo,
};
